import httpClient from "Api/httpClient";

const END_POINT = "/bill_payments";

const getBillPayments = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getBillPayment = (payment_id) => {
    if (!payment_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + payment_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printBillPayment = (payment_id) => {
    if (!payment_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?payment_id=" + payment_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createBillPayments = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateBillPayments = (payload, payment_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + payment_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteBillPayments = (payment_id) => {
    const DELETE_END_POINT = END_POINT + "/" + payment_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getBillPayments, getBillPayment, printBillPayment, createBillPayments, updateBillPayments, deleteBillPayments };
